import { Sprite, Loader } from 'pixi.js';
import vars from '../vars';

class MainStage {
  constructor(parent) {
    this.parent = parent;

    this.ref = new Sprite();
    this.sprite = new Sprite(Loader.shared.resources['images/PLAIN_BLUE'].texture);
    this.ref.addChild(this.sprite);
    this.resize();

    this.ref.sortableChildren = true;

    this.parent.addChild(this.ref);
  }

  resize() {
    this.sprite.width = vars.layout.FRAME_WIDTH;
    this.sprite.height = vars.layout.FRAME_HEIGHT;

    this.ref.position.y = vars.layout.FRAME_DIFFERENCE_TOP + vars.layout.FRAME_DIFFERENCE_BOTTOM;
  }

  destroy() {
    this.ref.destroy({ children: true });
  }
}

export default MainStage;
